import googlelogo from "../../Components/assets/Images/GoogleLogo.svg";

import { useEffect, useRef, useState } from "react";
import { EmailGoogleAuthAPICall } from "../../shared/APICalls";
import routesData from "../../shared/routes.json";
import { useNavigate } from "react-router-dom";

function ContinueWithGoogle({ handleCallBack, handleCallBackSuccess }) {
  const [user, setUser] = useState(null);
  const tokenClientRef = useRef(null);

  const navigationData = routesData;
  const navigate = useNavigate();

  //111452930568059399398
  //111452930568059399398

  useEffect(() => {
    if (!window.google) return;

    tokenClientRef.current = window.google.accounts.oauth2.initTokenClient({
      client_id:
        "1085784227894-t9v8aa1dok1ft3i90r8r4rfokr4nslvr.apps.googleusercontent.com",
      scope: "email profile",
      callback: async (response) => {
        if (response.access_token) {
          try {
            // 🔹 Fetch user info from Google
            const userInfo = await fetch(
              "https://www.googleapis.com/oauth2/v3/userinfo",
              {
                headers: {
                  Authorization: `Bearer ${response.access_token}`,
                },
              },
            );

            const userData = await userInfo.json();

            setUser(userData);
            console.log("user", userData);

            // 🔹 Prepare API payload
            const obj = {
              email: userData.email,
              google_client_id:
                "1085784227894-t9v8aa1dok1ft3i90r8r4rfokr4nslvr.apps.googleusercontent.com",
            };

            // 🔹 Store in session
            sessionStorage.setItem("client-name", userData.name || "");
            sessionStorage.setItem("client-email", userData.email || "");

            // console.log("obj", obj);

            // 🔹 Call your backend API
            EmailGoogleAuthAPICall(obj)
              .then((res) => {
                const responseData = res.data;
                // console.log("responseData",responseData)

                if (
                  responseData.data.next_stage &&
                  navigationData.hasOwnProperty(responseData.data.next_stage)
                ) {
                  navigate(navigationData[responseData.data.next_stage]);
                }
                handleCallBackSuccess(userData);
              })
              .catch((error) => {
                if (error?.response?.data?.message) {
                  handleCallBack(error.response.data.message);

                  setTimeout(() => {
                    handleCallBack("");
                  }, 5000);
                }
              });
          } catch (err) {
            console.error("Google login error:", err);
          }
        }
      },
    });
  }, []);

  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        tokenClientRef.current?.requestAccessToken();
      }}
      style={{
        // padding: "15px 24px",
        paddingLeft: "15px",
        // borderRadius: "30px",
        border: "0px solid var(--ds-outline)",
        borderLeft: "0px",
        background: "transparent",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        fontSize: "12px",
        color: "var(--ds-text-primary)",
        fontFamily: "inherit",
        // width:"100%",
        // height: "55px",
      }}
    >
      {/* Optional Google Icon */}
      <img src={googlelogo} alt="google" style={{ borderRadius: "30px" }} />
      Continue with Google
    </button>
  );
}

export default ContinueWithGoogle;
